import { useQuery } from 'react-query'
import { userService } from '@services/userService'
import { useAuthStore } from '@store/useAuthStore'

export function useEntryLevel() {
  const user = useAuthStore((s) => s.user)

  const query = useQuery(['entry-level-me', user?.id], () => userService.getEntryLevelStatus(), {
    enabled: !!user?.id,
    staleTime: 60_000,
  })

  // Só ativar IA quando o backend confirmar explicitamente (evita flash de acesso em Base durante o load)
  const aiEnabled = query.isSuccess && query.data?.aiEnabled === true
  const planCode = (query.data?.code ?? '').toLowerCase()

  return {
    ...query,
    aiEnabled,
    planCode: query.data?.code ?? null,
    planName: query.data?.name ?? null,
    storage: query.data?.storage ?? null,
    isFreemium: planCode === 'freemium',
    isBasic: planCode === 'basic',
    isPro: planCode === 'pro' || planCode === 'premium',
  }
}
